import { createFileRoute } from '@tanstack/react-router';
import { AccountSettingsPage } from '../../../features/account/AccountSettingsPage';

export const Route = createFileRoute('/$commiteeSlug/account/details')({
  component: AccountSettingsPage,
});
